import React, { useEffect, useState } from "react";
import Input from "../../components/FormComponents/Input";
import { useAxiosContext } from "../../context/AxiosContext";
import { useScreenContext } from "../../context/ScreenContext";
import { useTableContext } from "../../context/TableContext";
import { useTreeContext } from "../../context/TreeDataContext";
import { getDefaultConfig } from "../../utils/Config/getDefaultConfig";
import SingleSelectBox from "../../components/FormComponents/SingleSelectBox";
import Button from "../../components/FormComponents/Button";
import ButtonActionIcon from "../../components/BuilderComponents/ButtonActionIcon";
import BuilderModal from "../../Layouts/Modal/BuilderModal";
import TableTreeModal from "../../components/BuilderComponents/TableTreeModal";
import fileFolderConfig from "../../commonFunctions/fileFolderConfig";
import { toastError } from "../../utils/toastUtils";
import { insertNewFileOrFolder } from "../../utils/treeData/folderEditorUtils";

const AddNewBlockFromScreen = ({ onClose }) => {
  const [selectedType, setSelectedType] = useState("");
  const [allTable, setAllTable] = useState([]);
  const [selectedTypeTables, setSelectedTypeTables] = useState([]);
  const [selectedTableId, setSelectedTableId] = useState("");
  const [applicationBlockName, setApplicationBlockName] = useState("");
  const [isFieldOpen, setIsFieldOpen] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const [currentView, setCurrentView] = useState(1);
  const { tableData, rdbmsData } = useTableContext();
  const { axiosInstance, handleError, handleSuccess } = useAxiosContext();
  const { blocksExplorerData, setBlocksExplorerData } = useTreeContext();
  const [selectedBlock, setSelectedBlock] = useState("");
  const { layoutData, layouts, setLayouts } = useScreenContext();

  const handelTypeChange = (e) => {
    const type = e.target.value;
    if (type === "rdbms") {
      setSelectedTypeTables(rdbmsData);
    } else if (type === "appuser") {
      setSelectedTypeTables([
        {
          table_name: "Appuser",
          id: "appuser"
        }
      ]);
    } else {
      const data = allTable.filter((table) => table.table.table_type === type);
      setSelectedTypeTables(data);
    }
    setSelectedType(type);
    setSelectedTableId("");
  };

  const handleTableChange = (value) => {
    setSelectedTableId(value);
  };

  const updateScreenGrid = (data, type) => {
    const newLayout = JSON.parse(JSON.stringify(layoutData.current));
    newLayout[data.id] = { ...data, type: type };
    layoutData.current = newLayout;
    setLayouts([{ w: 12, h: 5, x: 0, y: 0, i: data.id }, ...layouts]);
  };

  const insertDataAndUpdateTree = async (folderId, config) => {
    try {
      const endPoint = folderId.name;
      const { data, message } = await axiosInstance.post(`/${endPoint}`, config);
      const newItem = fileFolderConfig.getFileConfig(
        data.id,
        data.name,
        folderId.parentData + "/" + folderId.name,
        true,
        true,
        selectedTableId,
        data.table_type
      );

      const newTree = insertNewFileOrFolder(blocksExplorerData, folderId, newItem);
      setBlocksExplorerData([...newTree]);
      updateScreenGrid(data, folderId.name);
      onClose();
      handleSuccess(message);
    } catch (error) {
      handleError(error);
    }
  };
  const createApplicationBlock = () => {
    const insertPopupData = { id: `desktop/${selectedBlock}`, name: selectedBlock, parentData: "desktop" };
    const { name, parentData } = insertPopupData;
    let config;
    if (name === "recordsview" && parentData === "desktop") {
      const recordvieDesktopConfg = getDefaultConfig("recordview_desktop");

      recordvieDesktopConfg.name = applicationBlockName;
      recordvieDesktopConfg.table_type = selectedType;
      recordvieDesktopConfg.config.layout.table_id = selectedTableId;
      recordvieDesktopConfg.config.layout.columns = selectedFields;

      config = recordvieDesktopConfg;
    }

    insertDataAndUpdateTree(insertPopupData, config);
  };
  const addColumnCallback = (data) => {
    const obj = selectedFields.find((field) => field.id === data.id);
    if (obj) {
      toastError("Field already exists");
      return;
    }
    const newArr = JSON.parse(JSON.stringify(selectedFields));
    newArr.push(data);
    setSelectedFields(newArr);
  };
  const removeColumn = async (id) => {
    const newArr = JSON.parse(JSON.stringify(selectedFields));
    const newFields = newArr.filter((user) => user.id !== id);
    setSelectedFields(newFields);
  };
  useEffect(() => {
    setAllTable(tableData);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    setSelectedFields([]);
  }, [selectedTableId]);

  const returnRadio = (type) => {
    return (
      <label className="builder_label" key={type} style={{ display: "flex", gap: "8px", margin: "0px" }}>
        <Input type="radio" name="type" value={type} checked={selectedType === type} onChange={handelTypeChange} />
        {type}
      </label>
    );
  };
  const renderBlockOptions = (name) => {
    const typesMap = {
      calendar: ["statemachine"],
      kanban: ["statemachine"],
      activitycard: ["statemachine"],
      recordsview: ["entity", "statemachine"],
      detailsview: ["entity", "statemachine"],
      mapsview: ["entity", "statemachine"],
      chart: ["entity", "statemachine"]
    };

    const types = typesMap[name] || ["entity", "statemachine"];
    return types.map((type) => returnRadio(type));
  };
  const renderBlockSelect = (arr) => {
    return (
      <>
        {arr.map((block) => (
          <label className="builder_label" key={block} style={{ display: "flex", gap: "8px", margin: "0px" }}>
            <Input
              type="radio"
              name="block"
              value={block}
              checked={selectedBlock === block}
              onChange={(e) => setSelectedBlock(e.target.value)}
            />
            {block}
          </label>
        ))}
      </>
    );
  };
  const getOptions = (tables) => {
    return tables.map((table) => ({
      id: table.table.id,
      name: table.table.table_name
    }));
  };

  return (
    <>
      <div className="builder_form">
        {currentView === 1 && (
          <div className="builder_form">
            <div className="builder_form">
              <Input
                label="Name"
                type="text"
                value={applicationBlockName}
                name="name"
                onChange={(e) => setApplicationBlockName(e.target.value)}
              />
            </div>

            <div className="builder_form">
              <label className="builder_label">Choose Block</label>
              <div className="blocks_type_radio">{renderBlockSelect(["recordsview"])}</div>
            </div>

            {selectedBlock && (
              <div className="builder_form">
                <label className="builder_label">Choose type</label>
                <div className="blocks_type_radio">{renderBlockOptions(selectedBlock)}</div>
              </div>
            )}
            <div className="builder_form">
              {selectedType && (
                <SingleSelectBox
                  selectedData={selectedTableId}
                  options={getOptions(selectedTypeTables)}
                  onChange={(obj) => handleTableChange(obj.id)}
                  placeholder="select"
                  label={`Choose ${selectedType}`}
                />
              )}
            </div>

            {selectedTableId !== "" && (
              <Button className="mt_3" onClick={() => setCurrentView(2)}>
                Next
              </Button>
            )}
          </div>
        )}

        {currentView === 2 && (
          <>
            <div style={{ width: "120px" }}>
              <Button onClick={() => setIsFieldOpen(true)}>Select Fields</Button>
            </div>

            <div className="selection_tag">
              {selectedFields.map((field) => (
                <div className="org_chip" key={field.id}>
                  <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                    <span style={{ fontSize: "14px", fontWeight: "600" }}>{field.display}</span>
                    <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
                      <ButtonActionIcon size="xsm" type="delete" onClick={() => removeColumn(field.id)} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
            {selectedFields.length > 0 && (
              <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
                <Button
                  onClick={() => {
                    setCurrentView(1);
                  }}
                >
                  Prev
                </Button>
                <Button onClick={createApplicationBlock}>Create</Button>
              </div>
            )}
          </>
        )}
      </div>

      <BuilderModal isOpen={isFieldOpen} onClose={() => setIsFieldOpen(false)} modalName="Select Columns">
        <TableTreeModal callbackFunction={addColumnCallback} tableId={selectedTableId} />
      </BuilderModal>
    </>
  );
};

export default AddNewBlockFromScreen;
